import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'descripcion',
    loadChildren: () =>
      import('./pages/descripcion/descripcion.module').then(
        (m) => m.DescripcionPageModule
      ),
  },
  {
    path: 'tyc',
    loadChildren: () =>
      import('./pages/tyc/tyc.module').then((m) => m.TycPageModule),
  },
  {
    path: 'registro',
    loadChildren: () =>
      import('./pages/registro/registro.module').then(
        (m) => m.RegistroPageModule
      ),
  },
  {
    path: 'instrucciones',
    loadChildren: () =>
      import('./pages/instrucciones/instrucciones.module').then(
        (m) => m.InstruccionesPageModule
      ),
  },
  {
    path: 'flexibilidad',
    loadChildren: () =>
      import('./pages/flexibilidad/flexibilidad.module').then(
        (m) => m.FlexibilidadPageModule
      ),
  },
  {
    path: 'adaptabilidad',
    loadChildren: () =>
      import('./pages/adaptabilidad/adaptabilidad.module').then(
        (m) => m.AdaptabilidadPageModule
      ),
  },
  {
    path: 'conocimiento',
    loadChildren: () =>
      import('./pages/conocimiento/conocimiento.module').then(
        (m) => m.ConocimientoPageModule
      ),
  },
  {
    path: 'agilidad',
    loadChildren: () =>
      import('./pages/agilidad/agilidad.module').then(
        (m) => m.AgilidadPageModule
      ),
  },
  {
    path: 'digital',
    loadChildren: () =>
      import('./pages/digital/digital.module').then((m) => m.DigitalPageModule),
  },
  {
    path: 'resultados',
    loadChildren: () =>
      import('./pages/resultados/resultados.module').then(
        (m) => m.ResultadosPageModule
      ),
  },
  {
    path: 'resultado2',
    loadChildren: () =>
      import('./pages/resultado2/resultado2.module').then(
        (m) => m.Resultado2PageModule
      ),
  },
  {
    path: 'preparate',
    loadChildren: () =>
      import('./pages/preparate/preparate.module').then(
        (m) => m.PreparatePageModule
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./pages/admin/admin.module').then((m) => m.AdminPageModule),
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
